/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesPaymentType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesPaymentType = typeof WebApiModelsEnumerationTypesPaymentType[keyof typeof WebApiModelsEnumerationTypesPaymentType];


export function WebApiModelsEnumerationTypesPaymentTypeFromJSON(json: any): WebApiModelsEnumerationTypesPaymentType {
    return WebApiModelsEnumerationTypesPaymentTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesPaymentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesPaymentType {
    return json as WebApiModelsEnumerationTypesPaymentType;
}

export function WebApiModelsEnumerationTypesPaymentTypeToJSON(value?: WebApiModelsEnumerationTypesPaymentType | null): any {
    return value as any;
}

